export default __webpack_public_path__ + "static/media/listening_music.8a4b7876.svg";